import { CaminoLogo } from "../../assets";
import { useMediaQuery } from "react-responsive";

const Logo = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  // return <h1 style={{ color: "#1679AB" }}>CAMINO</h1>;
  return (
    <img
      alt={1}
      src={CaminoLogo}
      style={{
        height: isMobile ? "30px" : "20px",
        objectFit: "cover",
      }}
    />
  );
};

export default Logo;
